export default "__VITE_ASSET__fc4538ea__"